import { RootState } from 'store/rootReducer';

export const LogoutSuccessContentSelector = (state: RootState) => state.content.autoLogoutSuccess;
